module.exports = __webpack_public_path__ + "static/media/diamond.fe17fdef.jpg";